import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { licensesManageService } from '../api/licensesManageService';
import { LicenseStatus, LicenseType } from '../types/manageLicenses';
import type { LicenseFilterState, ManageLicensesListInput } from '../types/manageLicenses';

export const licenseListQueryKey = (filters: LicenseFilterState) => ['manage-licenses', 'list', filters];

export function useLicenseListQuery(filters: LicenseFilterState) {
  const input = toInput(filters);
  return useQuery({
    queryKey: licenseListQueryKey(filters),
    queryFn: () => licensesManageService.list(input),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}

function toInput(f: LicenseFilterState): ManageLicensesListInput {
  return {
    filterText: f.q || undefined,
    status: f.status === 'all' ? undefined : (f.status as LicenseStatus),
    licenseType: f.type === 'all' ? undefined : (f.type as LicenseType),
    publisherId: f.publisherIds[0],
    bookId: f.bookIds[0],
    booksellerId: f.booksellerIds[0],
    activatedAfter: f.activatedAfter,
    activatedBefore: f.activatedBefore,
    expiresAfter: f.expiresAfter,
    expiresBefore: f.expiresBefore,
    expiringWithinDays: f.expiringWithinDays,
    isPerpetual: f.isPerpetual,
    hasExternalLicenseId: f.hasExternalLicenseId,
    hasActiveSessions: f.hasActiveSessions,
    atOrOverDeviceLimit: f.atOrOverDeviceLimit || undefined,
    includeDeleted: f.includeDeleted,
    sorting: `${f.sort} ${f.dir}`,
    skipCount: (f.page - 1) * f.pageSize,
    maxResultCount: f.pageSize,
  };
}
